import React, { useRef } from 'react';
import { IconButton, Tooltip } from '@axiom/ui';

import { ChatAttachmentAcceptUtil } from '../../utils/chat-attachment-accept-util';

export type ChatAttachButtonProps = {
  addAttachments: (files: FileList | null) => void;
  /** A conversation that takes no more sends takes no more attachments either. */
  disabled?: boolean;
};

/**
 * ChatAttachButton - I am the paperclip on the input bar: the hidden file input and the control
 * that opens it. ONLY concerned with choosing files - what happens to them afterwards is the
 * composer's.
 */
export const ChatAttachButton = ({
  addAttachments,
  disabled,
}: ChatAttachButtonProps) => {
  const attachmentInputRef = useRef<HTMLInputElement | null>(null);

  return (
    <>
      <input
        accept={ChatAttachmentAcceptUtil.acceptAttribute()}
        multiple
        data-test="ATTACHMENT_INPUT"
        hidden
        name="ATTACHMENT_INPUT"
        onChange={event => {
          addAttachments(event.target.files);
          event.target.value = '';
        }}
        ref={attachmentInputRef}
        type="file"
      />
      <Tooltip
        fade
        hideClose
        name="ADD_ATTACHMENT_EXPLANATION"
        position="left"
        variation="minimal"
        anchor={
          <IconButton
            disabled={disabled}
            icon="plus"
            name="ADD_ATTACHMENT"
            onClick={() => {
              attachmentInputRef.current?.click();
            }}
            pattern="secondary"
            size="large"
            variation="minimal"
          />
        }
      >
        Attach a file to your prompt - PDF, Word, text or image
      </Tooltip>
    </>
  );
};
